import { FormControl, InputLabel, Select } from '@material-ui/core';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';

const StyledSelect = ({
  label,
  value,
  onChange,
  children,
  borderRadius = 6,
  completed = true,
  disabled = false,
  name,
  className,
  ...props
}) => {
  const selectClass = css({
    '.MuiSelect-filled.MuiSelect-filled': {
      padding: "6px 44px 6px 20px !important", // car la fleche fais 24 donc 20 + 24 = 44
    },
    '.MuiFilledInput-root': {
      border: completed ? '1px solid #C0D9FF' : '1px solid #A80202',
      backgroundColor: completed ? '#F3F7FF' : '#fbd3d5',
      borderRadius: `${borderRadius}px !important`,
      fontSize: '12px !important',

      "&:hover": {
        borderColor: "#0060f9 !important",
        "svg": {
          fill: "#0060f9 !important",
        },
        "& .MuiSelect-filled.MuiSelect-filled": {
          color: "#0060f9 !important",
        },

        ".MuiSelect-filled.MuiSelect-filled": {
          color: "#0060f9 !important",
        },
      },
    },
    '.MuiInputBase-root': {
      borderRadius: `${borderRadius}px !important`,
      minHeight: '30px',
      color: '#152652',
    },
    '.MuiSelect-filled.MuiSelect-filled ': {
      color: "#5D75A8",
      fontFamily: "Montserrat",
      fontWeight: "500",
      fontSize: "13.5px",
    },
    '.MuiSelect-select:focus': {
      borderRadius: `${borderRadius}px !important`,
    },
    '.MuiInputLabel-root': {
      color: completed ? '#5D75A8' : '#A80202',
    },
    '.MuiInputLabel-shrink': {
      transform: 'translate(14px, -12px) scale(0.75)',
    },
    '.MuiFilledInput-underline:before': {
      display: 'none',
    },
  });

  return (
    <FormControl
      variant="filled"
      fullWidth
      disabled={disabled}
      className={selectClass}
    >
      {label && <InputLabel htmlFor={name}>{label}</InputLabel>}
      <Select
        value={value}
        onChange={onChange}
        displayEmpty
        className={
          className
        }
        inputProps={{
          name,
          id: name,
        }}
        {...props}
      >
        {children}
      </Select>
    </FormControl>
  );
};

StyledSelect.propTypes = {
  label: PropTypes.node,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  borderRadius: PropTypes.number,
  completed: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  className: PropTypes.string,
};

export default StyledSelect;
